import {faBullseye} from '@fortawesome/free-solid-svg-icons';
import {decorate, observable} from 'mobx';
import {BaseModel} from './base';

export class KeyPerformanceIndicatorTarget extends BaseModel {
  static faIcon = faBullseye;

  searchableProperties = [
    'value',
    'keyPerformanceIndicator.name',
    'material.name',
    'material.no',
    'workplace.name',
    'workplace.no',
  ];

  static prepareApiPayload(model) {
    return {
      id: model.id,
      keyPerformanceIndicatorId: model.keyPerformanceIndicatorId,
      workplaceId: model.workplaceId || null,
      materialId: model.materialId || null,
      value: model.value,
    };
  }

  populateAttributesFromStore(rootStore) {
    super.populateAttributesFromStore(rootStore);
    this.keyPerformanceIndicator = rootStore.keyPerformanceIndicatorStore.getById(this.keyPerformanceIndicatorId);
    this.workplace = rootStore.workplaceStore.getById(this.workplaceId);
    this.material = rootStore.materialStore.getById(this.materialId);
  }
}

decorate(KeyPerformanceIndicatorTarget, {
  id: observable,
  keyPerformanceIndicatorId: observable,
  keyPerformanceIndicator: observable,
  workplaceId: observable,
  workplace: observable,
  materialId: observable,
  material: observable,
  value: observable,
  createdAt: observable,
  createdBy: observable,
  updatedAt: observable,
  updatedBy: observable,
});
